import React from "react";

type Props = {
    id: any;
    label?: string
} & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

export default function Range(props: Props) {
    return (
        <div>
            <label
                dangerouslySetInnerHTML={{
                    __html: props.label,
                }}
                htmlFor={props.id}
                className="mb-2 block text-sm font-medium text-textColor"
            >
            </label>
            <input
                {...props}
                id={props.id}
                type="range"
                className="h-2 w-full cursor-pointer appearance-none rounded-lg bg-gray-200"
            />
        </div>
    );
}
